import { breakpoints } from '@rocheglobal/component-library-dot-com/src/style/base';
import React, {
  useEffect, useRef, useState,
} from 'react';
import { ExternalDataService } from '../../services/external-data';

export interface PipelineDiagnosticsEntry {
  type: string,
  area: string,
  productName: string,
  description: string,
  color: string,
  title: string,
}

export const RochePipelineDiagnostics = (): JSX.Element => {
  const container = useRef(null);
  const [content, setContent] = useState({});
  const [isMobile, setMobile] = useState(false);
  const getClientWidth = () => (typeof document !== 'undefined' ? document.body.clientWidth : null);
  const getIsMobile = () => getClientWidth() < breakpoints.large;

  useEffect(() => {
    const handleResize = () => setMobile(getIsMobile);

    window.addEventListener('resize', handleResize);

    handleResize();

    // eslint-disable-next-line consistent-return
    return function cleanup(): void {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const { current }: { current: HTMLElement } = container;
    if (!current) {
      return;
    }

    ExternalDataService.getPipelineDiagnostics()
      .then((response: { Items: PipelineDiagnosticsEntry[] }) => {
        setContent(response.Items);
      });
  }, []);

  // TODO: rendering the children table and rows here instead of the component library itself
  return (
    <div ref={container}>
      <roche-pipeline-diagnostics
        content={JSON.stringify(content)}
        is-mobile={isMobile}
      ></roche-pipeline-diagnostics>
    </div>
  );
};
